export default __webpack_public_path__ + "static/media/studio20.22f88564.png";